export default __webpack_public_path__ + "static/media/hot-lead.834b00b9.png";